import { API_URL } from '@moxie/constants';
import { IResponse } from '@shared-components/models';
import { crmAxios } from '@crm/services.api';

const getChecklists = async (): Promise<IResponse> => {
  return crmAxios.get(`${API_URL.CRM_API_CHECKLISTS}`);
};

export { getChecklists };
